import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import Input from "../../../../common/FormComponents/Input";
import { useEffect, useState } from "react";
import FormSectionHeader from "../../../../common/Form/FormSectionHeader";
import FormSectionGrid from "../../../../common/Form/FormSectionGrid";

const GuardianForm = ({
  control,
  errors,
  pageText,
  emailGuardian,
  confirmEmailGuardian,
  candidateData,
  examRules,
}: any) => {
  const [phoneNumber, setPhoneNumber] = useState<any>(
    candidateData?.guardianmobilenumber
      ? candidateData?.guardianmobilenumber
      : ""
  );
  const [telephoneNumber, setTelephoneNumber] = useState<any>(
    candidateData?.guardianphonenumber ? candidateData?.guardianphonenumber : ""
  );
  const [guradianEmailError, guardianSetEmailError] = useState<any>(false);
  const [guardianConfirmEmailError, guardianSetConfirmEmailError] =
    useState<any>(false);
  const [getConfirmEmail, setConfirmEmail] = useState<any>(
    candidateData?.guardianConfirmEmail || ""
  );
  const [emailValue, setEmailValue] = useState("");

  const togglePhoneNumber = (e: any, type = "") => {
    const value = e.target.value;
    const regex = /^[0-9]*$/;
    if (regex.test(value)) {
      type === "telephone" ? setTelephoneNumber(value) : setPhoneNumber(value);
    }
    if (value === "") {
      setPhoneNumber(value);
    }
  };

  const handleEmailChange = (e: any) => {
    const emailValue = e.target.value;
    if (getConfirmEmail && emailValue !== getConfirmEmail) {
      guardianSetConfirmEmailError(true);
    }
    if (emailValue === getConfirmEmail) {
      guardianSetConfirmEmailError(false);
    }
  };

  useEffect(() => {
    emailGuardian(guradianEmailError);
    confirmEmailGuardian(guardianConfirmEmailError);
  }, [guradianEmailError, guardianConfirmEmailError]);

  return (
    <>
      <FormSectionHeader>
        {pageText?.labelsMetadata?.guardianInformation}
      </FormSectionHeader>
      {examRules?.examRegistrationRules?.guardianMessage && (
        <Box
          sx={{
            marginTop: "40px",
            fontWeight: "700",
            "& p": {
              margin: "0",
            },
          }}
          dangerouslySetInnerHTML={{
            __html: examRules?.examRegistrationRules?.guardianMessage,
          }}
        ></Box>
      )}
      <FormSectionGrid>
        <Grid xs={12} sm={6} className="field">
          <Input
            name="guardianfirstName"
            type="text"
            control={control}
            placeholder={
              pageText?.validationMessages?.pleaseEnterGuardianFirstName
            }
            errors={errors}
            label={`${pageText?.labelsMetadata.guardianFirstName} *`}
            rules={{
              required:
                pageText?.validationMessages?.pleaseEnterGuardianFirstName,
            }}
          />
        </Grid>
        <Grid xs={12} sm={6} className="field">
          <Input
            name="guardianlastName"
            type="text"
            control={control}
            placeholder={
              pageText?.validationMessages?.pleaseEnterGuardianLastName
            }
            errors={errors}
            label={`${pageText?.labelsMetadata.guardianLastName} *`}
            rules={{
              required:
                pageText?.validationMessages?.pleaseEnterGuardianLastName,
            }}
          />
        </Grid>
        <Grid xs={12} sm={6} className="field">
          <Input
            name="guardianmobilenumber"
            value={phoneNumber}
            noUseFieldValue={true}
            onPhoneChange={(e: any) => togglePhoneNumber(e)}
            control={control}
            maxLength={15}
            placeholder={
              pageText?.validationMessages
                ?.pleaseGuardianEnterPhoneOrMobileNumber
            }
            errors={errors}
            label={`${pageText?.labelsMetadata.guardianMobile} *`}
            rules={{
              required:
                pageText?.validationMessages
                  ?.pleaseGuardianEnterPhoneOrMobileNumber,
            }}
          />
        </Grid>
        <Grid xs={12} sm={6} className="field">
          <Input
            name="guardianphonenumber"
            control={control}
            maxLength={15}
            placeholder={
              pageText?.validationMessages
                ?.pleaseGuardianEnterPhoneOrMobileNumber
            }
            errors={errors}
            value={telephoneNumber}
            noUseFieldValue={true}
            onPhoneChange={(e: any) => togglePhoneNumber(e, "telephone")}
            label={`${pageText?.labelsMetadata.guardianTelephonenumberAlternativemobilenumber} *`}
            rules={{
              required:
                pageText?.validationMessages
                  ?.pleaseGuardianEnterPhoneOrMobileNumber,
            }}
          />
        </Grid>
        <Grid xs={12} sm={6} className="field">
          <Input
            name="guardianEmail"
            control={control}
            placeholder={pageText?.validationMessages?.pleaseEnterEmailAddress}
            errors={errors}
            outsideError={
              guradianEmailError
                ? pageText?.validationMessages.emailAddressIsNotValid
                : undefined
            }
            label={`${pageText?.labelsMetadata?.emailAddressLabel} *`}
            onEmailChange={(e: any) => {
              if (!e.target.value) {
                guardianSetEmailError(false);
              } else {
                const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                guardianSetEmailError(!emailPattern.test(e.target.value));
                setEmailValue(e.target.value);
              }
              handleEmailChange(e);
            }}
            rules={{
              required: pageText?.validationMessages?.pleaseEnterEmailAddress,
            }}
          />
        </Grid>
        <Grid xs={12} sm={6} className="field">
          <Input
            name="guardianConfirmEmail"
            control={control}
            placeholder={pageText?.validationMessages?.pleaseEnterEmailAddress}
            errors={errors}
            outsideError={
              guardianConfirmEmailError
                ? getConfirmEmail
                  ? pageText?.validationMessages
                      .emailAndConfirmEmailAddressDoesNotMatching
                  : pageText?.validationMessages.pleaseEnterConfirmEmailAddress
                : undefined
            }
            label={`${pageText?.labelsMetadata?.confirmEmailAddressLabel} *`}
            onEmailChange={(e: any) => {
              setConfirmEmail(e.target.value);
              if (emailValue === e.target.value) {
                handleEmailChange(e);
                guardianSetConfirmEmailError(false);
              } else {
                guardianSetConfirmEmailError(true);
              }
              if (!e.target.value) {
                guardianSetConfirmEmailError(false);
              }
            }}
            rules={{
              required:
                pageText?.validationMessages?.pleaseEnterConfirmEmailAddress,
            }}
          />
        </Grid>
      </FormSectionGrid>
    </>
  );
};

export default GuardianForm;
